// シークレットページリダイレクト(直前ページが商品ページだった場合は、直前ページにリダイレクトする)
const loginTransition = document.querySelector('.login-transition');
const ref = document.referrer;
if (ref.match(/products/) || ref.match(/collection/)) {
  loginTransition.value = ref;
} 